import { render } from "./SysModelDialog.vue?vue&type=template&id=37564f6b&scoped=true"
import script from "./SysModelDialog.vue?vue&type=script&lang=js"
export * from "./SysModelDialog.vue?vue&type=script&lang=js"

import "./SysModelDialog.vue?vue&type=style&index=0&id=37564f6b&scoped=true&lang=css"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37564f6b"]])

export default __exports__